import React, { lazy } from 'react';
import { Route } from 'react-router-dom';

const WarehouseHealth = lazy(() => import('../components/warehouse/WarehouseHealth'));
const ForecastInspector = lazy(() => import('../components/demand/ForecastInspector'));
const SignalsInbox = lazy(() => import('../components/demand/SignalsInbox'));
const InventoryPage = lazy(() => import('../components/inventory-page'));
const InventoryDetailPage = lazy(() => import('../components/inventory-page/InventoryDetailPage'));
const InventoryHealthPage = lazy(() => import('../components/inventory-page/InventoryHealthPage'));

export const inventoryRoutes = (
  <>
    <Route path="/inventory" element={<InventoryPage />} />
    <Route path="/inventory-health" element={<InventoryHealthPage />} />
    <Route path="/inventory/:ean" element={<InventoryDetailPage />} />
    <Route path="/warehouse/health" element={<WarehouseHealth />} />
    <Route path="/demand/forecast" element={<ForecastInspector />} />
    <Route path="/demand/signals" element={<SignalsInbox />} />
  </>
);
